module.exports = "/shared/img/delete-purple.png";


//////////////////
// WEBPACK FOOTER
// ./src/ui/img/delete-purple.png
// module id = 15
// module chunks = 13